import React, { ComponentProps, forwardRef, HTMLAttributes } from 'react';
import { Typography as AntdTypography } from 'antd';

const TypographyBase = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>((props, ref) => <AntdTypography {...props} ref={ref} />);

const Typography = TypographyBase as typeof TypographyBase & {
  Text: typeof AntdTypography.Text;
  Link: typeof AntdTypography.Link;
  Title: typeof AntdTypography.Title;
  Paragraph: typeof AntdTypography.Paragraph;
};

Typography.displayName = 'Typography';

Typography.Text = AntdTypography.Text;
Typography.Link = AntdTypography.Link;
Typography.Title = AntdTypography.Title;
Typography.Paragraph = AntdTypography.Paragraph;

export type TypographyProps = ComponentProps<typeof Typography>;
export { Typography };
